import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=7bf0cfed&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bf0cfed')) {
      api.createRecord('7bf0cfed', component.options)
    } else {
      api.reload('7bf0cfed', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=7bf0cfed&", function () {
      api.rerender('7bf0cfed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22A76H66ogMlr/JS/comp/openstreetmap.vue"
export default component.exports